import { LockIcon, WifiIcon } from "@xola/icons";
import { Badge } from "@xola/ui-kit";
import clsx from "clsx";
import { isAllDay } from "common";
import React from "react";
import { AllowedPrivacy, Experience, Timeslot, Waitlist } from "types";
import { useResource } from "../../hooks/useResource";
import { getCustomerName } from "../../models/Purchase";
import { useCreatePurchaseStore } from "../../stores/createPurchaseStore";
import { ProductImage } from "../Common/ProductImage";
import { Loader } from "../Loader";
import { DateInfoLine } from "./EventSummaryTile";

interface WaitlistTimeslotSummaryTileTileProps {
    timeslot: Timeslot;
    className?: string;
}

export const WaitlistTimeslotSummaryTile = ({ timeslot, className }: WaitlistTimeslotSummaryTileTileProps) => {
    const waitlistId = useCreatePurchaseStore((state) => state.waitlistId);

    const { data: experience, isLoading: isLoadingProduct } = useResource<Experience>(["products", timeslot.product]);

    const { data: waitlist, isLoading: isLoadingWaitlist } = useResource<Waitlist>(["waitlists", waitlistId]);

    if (isLoadingWaitlist || isLoadingProduct) {
        return <Loader />;
    }

    const allDay = isAllDay(experience!);

    const startDateTime = timeslot.arrivalDatetime;

    if (!waitlist) {
        return null;
    }

    return (
        <div className={clsx("mb-5 flex space-x-1 rounded-lg bg-gray-lighter p-4", className)}>
            <ProductImage size="small" className="mr-0 rounded-lg" product={experience!} />
            <div className="w-full space-y-2">
                <div className="text-base font-bold leading-4" data-testid="event-summary-experience-name">
                    {experience?.name}
                </div>

                <DateInfoLine date={startDateTime} label="" quantity={waitlist.items[0].quantity} allDay={allDay} />

                <div className="flex space-x-2">
                    {experience?.virtualMeeting?.enabled ? (
                        <Badge color="primary">
                            <WifiIcon />
                        </Badge>
                    ) : null}
                    {timeslot.privacy === AllowedPrivacy.PRIVATE ? (
                        <Badge color="warning" icon={<LockIcon />}>
                            {getCustomerName(waitlist)}
                        </Badge>
                    ) : null}
                </div>
            </div>
        </div>
    );
};
